export const importIntlPolyfill = () => {
  if (!global.Intl) {
    require('intl');
    require('intl/locale-data/jsonp/en.js');
  }
};



// WEBPACK FOOTER //
// ./helpers/polyfill.helper.js